import React from "react";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import { useGridApiContext } from "@mui/x-data-grid-pro";

const ExportCsvButton = () => {
    const apiRef = useGridApiContext();

    return (
        <Button
            id="gridBtnDownload"
            variant="outlined"
            endIcon={<DownloadIcon />}
            onClick={() =>
                apiRef.current.exportDataAsCsv({
                    delimiter: ";",
                    utf8WithBom: true,
                })
            }
        >
            CSV
        </Button>
    );
};

export default ExportCsvButton;
